module.exports = __webpack_public_path__ + "media/country_flags/tv-882c050a.png";